import responses from "./responses";
import registration from "./registration";

export default {
  responses,
  registration,
};
